import { HttpErrorResponse, HttpEvent, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from '../services/auth.service';
import { TokenStorageService } from '../services/token-storage.service';
import { TokenRefreshService } from '../services/token-refresh.service';

/**
 * این Interceptor دو وظیفه دارد:
 * ۱) اضافه کردن هدر Authorization به تمام درخواست‌های API (به جز auth/register و auth/login)
 * ۲) در صورت پاسخ 401 (توکن منقضی)، تلاش خودکار برای Refresh و تکرار درخواست اصلی
 */
export const authInterceptor: HttpInterceptorFn = (req, next): Observable<HttpEvent<unknown>> => {
  const tokenStorage = inject(TokenStorageService);
  const authService = inject(AuthService);
  const router = inject(Router);
  const tokenRefresh = inject(TokenRefreshService);

  const isAuthEndpoint =
    req.url.startsWith(`${environment.apiBaseUrl}/auth/login`) ||
    req.url.startsWith(`${environment.apiBaseUrl}/auth/register`);

  const accessToken = tokenStorage.getAccessToken();
  const authorizedReq = accessToken && !isAuthEndpoint
    ? req.clone({ setHeaders: { Authorization: `Bearer ${accessToken}` } })
    : req;

  return next(authorizedReq).pipe(
    catchError((error: HttpErrorResponse) => {
      const isUnauthorized = error.status === 401;
      const isRefreshEndpoint = req.url.startsWith(`${environment.apiBaseUrl}/auth/refresh`);

      if (!isUnauthorized || isRefreshEndpoint || isAuthEndpoint) {
        return throwError(() => error);
      }

      return tokenRefresh.handle401Error(req, next).pipe(
        catchError((refreshError: unknown) => {
          authService.forceLocalLogout();
          router.navigateByUrl('/auth/login');
          return throwError(() => refreshError);
        }),
      );
    }),
  );
};